import './Panel.scss';
import { ButtonsMixin } from '@components/Mixin/ButtonsMixin/ButtonsMixin.js';
import { Modal } from '@components/Component/Container/Modal/Modal.js';
import { containerAutoResize, createElement, isMobile } from '@components/Utility/index.js';
import { map } from 'rxjs';
import DIContainer from '@components/DependencyInjectionContainer.js';
export class Panel extends ButtonsMixin(Modal) {
    get includeCloseButton() { return this._includeCloseButton; }
    set includeCloseButton(value) {
        this._propertySet('includeCloseButton', value);
        this.refreshButton('close');
    }
    get side() { return this._side; }
    set side(side) {
        this._propertySet('side', side);
    }
    get icon() { return this._icon; }
    set icon(value) {
        this._propertySet('icon', value);
    }
    get includeModalButton() { return this._includeModalButton; }
    set includeModalButton(value) {
        this._propertySet('includeModalButton', value);
        this.refreshButton('modal');
    }
    get caption() { return this._caption || ''; }
    set caption(value) {
        this._propertySet('caption', value);
    }
    get tooltip() { return this._tooltip || ''; }
    set tooltip(value) {
        this._propertySet('tooltip', value);
    }
    get modalMode() { return this._modalMode; }
    set modalMode(modalMode) {
        this._propertySet('modalMode', modalMode);
        this.renderModalMode();
    }
    renderModalMode() {
        const dragManager = DIContainer.getInstance('DragManager');
        if (!this.drawn) {
            return;
        }
        this.rootElement.classList.toggle('docked', !this._modalMode);
        if (!this.modalMode) {
            this.rootElement.style.top = '';
            this.rootElement.style.left = '';
            this.rootElement.style.height = '';
        }
        else if (!this.rootElement.style.height) {
            this.rootElement.style.height = '500px';
        }
        this.attachModal();
        const modalDragArea = this.rootElement.querySelector('.modal-drag-area');
        if (modalDragArea) {
            dragManager.toggleDraggable(modalDragArea, this.modalMode);
        }
        const resizerBottom = this.rootElement.querySelector('.resizer-bottom');
        const resizerBottomRight = this.rootElement.querySelector('.resizer-bottom-right');
        const resizerBottomLeft = this.rootElement.querySelector('.resizer-bottom-left');
        resizerBottom.classList.toggle('d-none', !this._modalMode);
        resizerBottomRight.classList.toggle('d-none', !this._modalMode);
        resizerBottomLeft.classList.toggle('d-none', !this._modalMode);
        this.handleResize();
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Panel';
        this._includeCloseButton = true;
        this._icon = '';
        this._includeModalButton = !isMobile();
        this._modalButtonIcon = 'dock_to_right'; //this.propertyGet$('modalMode').pipe(map((b: boolean) => b ? `dock_to_${this.side === 'left' ? 'right' : 'left'}` : 'open_in_new'))
        this.width = '400';
        this.hidden = true;
        this.modalMode = false;
        this.lazyDrawContent = true;
        this.screenCoverRoot = 'none';
        this.side = 'right';
        this.destroyOnSubmit = false;
        this.sheet = false;
    }
    handleEnterKey() {
        // don't use modal behavior for enter key on panels, just do nothing on the basic panel.
        return false;
    }
    draw() {
        // this.contentContainer = this.rootElement;
        super.draw();
        this.anchorElement = createElement('span', ['d-none']);
        this.rootElement.after(this.anchorElement);
        this.renderModalMode();
    }
    renderHiddenState() {
        if (this.drawn && !this._hiddenState) {
            this.drawChildren();
        }
        super.renderHiddenState();
        if (this.drawn) {
            if (!this._hiddenState) {
                // just in case someone interacts with the panel to show/hide instead of the filterset, we need to keep them synced.
                this.parentComponentGet().currentPanelSet(this, this.side);
                // setTimeout(() => this.handleResize(), 5);
            }
            else if (this.parentComponentGet().currentPanelGet(this.side) === this) {
                this.parentComponentGet().currentPanelSet(undefined, this.side);
            }
            this.updateScreenBreakpoint();
        }
    }
    attachModal() {
        if (this.modalMode) {
            super.attachModal(this.anchorElement || null);
            this.centerModal();
        }
        else {
            this.anchorElement?.before(this.rootElement);
            this.attachedToDOM = true;
        }
    }
    updateScreenBreakpoint() {
        super.updateScreenBreakpoint();
        this.handleResize();
    }
    handleResize() {
        if (!this.modalMode) {
            // for panels with grids, ie. quote sections, attempt to make the grid fill the panels available space
            const container = this.childContainer;
            containerAutoResize(container, '.autoResize', container.parentElement.clientHeight - 20); // (-10 for padding 5px (top and bottom))
        }
    }
    centerModal() {
        if (this.modalMode) {
            super.centerModal();
        }
    }
    initializeButtons() {
        this.buttonAdd({
            icon: this.propertyGet$('modalMode').pipe(map((b) => b ? `dock_to_${this.side === 'left' ? 'right' : 'left'}` : 'open_in_new')),
            containerId: 'control',
            id: 'modal',
            includeProperty: 'includeModalButton',
            defaultIncludePropertyValue: true,
            onClick: () => {
                this.modalMode = !this.modalMode;
            }
        });
        this.buttonAdd({
            icon: 'close',
            containerId: 'control',
            id: 'close',
            includeProperty: 'includeCloseButton',
            defaultIncludePropertyValue: true,
            onClick: () => {
                this.hide();
            }
        });
    }
    captionTypesSet() {
        this.captionTypes = {
            title: 'title',
            caption: 'caption',
            tooltip: 'tooltip'
        };
    }
    renderWidth() {
        super.renderWidth();
        this.updateScreenBreakpoint();
    }
    buttonContainerCreate() {
        const buttonContainer = this.rootElement.querySelector('.button-container');
        this.buttonContainers.set('', buttonContainer);
        const buttonContainerControls = this.rootElement.querySelector('.control-button-container');
        this.buttonContainers.set('control', buttonContainerControls);
    }
    modalContentTemplate() {
        return `<div class="modal-content">
	<div class="child-container"></div>
</div>
<div class="panel-footer">
	<div class="button-container"></div>
</div>`;
    }
}
Panel.VERSION = '$Revision: 111642 $';
